import { GerenciamentoCurso } from './gerenciamento-curso.model';
import { AnexoRecurso } from './anexo-recurso.model';
export class RecursoFiltro {
    IdModel: number;
    Justificativa: string;
    AnexoRecurso: AnexoRecurso[];
    Interpor: boolean;
    CursoDto: GerenciamentoCurso;
    constructor() {
        this.AnexoRecurso = [];
        this.Justificativa = '';
        this.IdModel = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/entity/recurso-filtro.model.ts